import cx from 'classnames'

export default function Container({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cx('relative p-6 space-y-4', className)}>{children}</div>
}
